/**
 * Schmales Banner ganz oben — zeigt die aktuelle Umgebung.
 * - prod: kein Banner (saubere Sicht für Endkunden)
 * - staging: orange Warnfarbe
 * - local: dunkelgrau / dezent
 */
import { AlertTriangle, Code } from 'lucide-react';
import { useStage } from '../lib/useStage';

export default function StageBanner() {
  const stage = useStage();
  if (stage === 'prod') return null;

  if (stage === 'staging') {
    return (
      <div className="w-full bg-amber-500 text-amber-950 text-xs font-semibold tracking-wide flex items-center justify-center gap-2 py-1 border-b border-amber-700">
        <AlertTriangle size={14} />
        STAGING — Test-Umgebung. Änderungen sind nicht produktiv.
      </div>
    );
  }

  return (
    <div className="w-full bg-slate-700 text-slate-200 text-xs font-semibold tracking-wide flex items-center justify-center gap-2 py-1 border-b border-slate-600">
      <Code size={14} />
      LOKALE ENTWICKLUNG
    </div>
  );
}
